export const shoppingTipsArticleId = 2;
